import * as React from "react";
import TextField from "@mui/material/TextField";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DatePicker";
import DateFnsUtils from "@date-io/date-fns";
import jaLocale from "date-fns/locale/ja";
import format from "date-fns/format";

import moment from "moment";

class ExtendedUtils extends DateFnsUtils {
    getCalendarHeaderText(date) {
        return format(date, "yyyy MMM", { locale: this.locale });
    }
    getDatePickerHeaderText(date) {
        return format(date, "MMMd日", { locale: this.locale });
    }
}

interface Props {
    onChangeMethod: any;
    initialDate: string;
}

export const MonthDayPicker: React.FC<Props> = (props: Props) => {
    const newDate =
        props.initialDate == (null || "") ? null : new Date(props.initialDate);

    const [open, setOpen] = React.useState(false);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
            <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
                <DesktopDatePicker
                    label=""
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={newDate}
                    clearable
                    onChange={(ev) => {
                        const out = moment(ev).format("YYYY-MM-DD");
                        props.onChangeMethod(out);
                    }}
                    showDaysOutsideCurrentMonth
                    renderInput={(params) => (
                        <TextField
                            variant="filled"
                            size="small"
                            onClick={() => {
                                setOpen(true);
                            }}
                            sx={{
                                cursor: "pointer",
                                ".MuiFilledInput-input": {
                                    pt: 3.5,
                                    pb: 3.5,
                                },
                            }}
                            {...params}
                        />
                    )}
                    inputFormat="yyyy/MM/dd"
                    mask="____/__/__"
                />
            </MuiPickersUtilsProvider>
        </LocalizationProvider>
    );
};
